import { engineComponent } from "neo-common";
import { HtmlElement } from "./HtmlElement";
import { ComponentTypes } from "../../Components/ComponentTypes";

/**
 * HtmlDataSliderElement is used for data representing in bar or slider.
 * @class HtmlDataSliderElement
 * @extends HtmlElement
 */
@engineComponent(ComponentTypes.HtmlElement)
export class HtmlDataSliderElement extends HtmlElement {
    constructor() {
        super();
    }

    /**
     * Get attributes from xml and set up supported properties.
     * @method create
     * @param node is Element from xml
     * @retutn void
     */
    create(node: Element): void {
        super.create(node);
    }

    /**
     * Set text or data for this element.
     * @method setText
     * @param text string
     * @return void
     */
    setText(value?: string): void {
        if (value != null) {
            var parsedValue: Array<string> = value.split("/");
            if (this.instance != null && parsedValue.length === 2) {
                this.instance.style.width = (parseInt(parsedValue[0]) / parseInt(parsedValue[1])) * 100 + "%";
            }
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/HTMLComponents/Elements/HtmlDataSliderElement.ts
 **/